import { Popover } from "@mui/material";
import { Theme } from "@emotion/react";
import { borderRadius } from "@iventis/styles/src/atomic-rules";
import { InteractiveElement } from "@iventis/styles/src/components";
import { iconButtonWidth, styled } from "@iventis/styles";

export const StyledDataTableWrapper = styled.section<{ maxWidth: string }>`
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }: { theme: Theme }) => theme.shades.five};

    .ag-grid-iventis {
        margin-left: 5px;
        height: 100%;
        max-width: ${(props) => props.maxWidth};
    }
`;

export const StyledToolBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ${({ theme }: { theme: Theme }) => theme.sizes.iconButtonWidth};
    border-bottom: 1.5px solid rgba(0, 0, 0, 0.05);
    padding: 10px 0;
    .MuiFormControl-marginNormal {
        margin-top: 0;
        margin-bottom: 0;
    }
`;

export const StyledColumnsDisplayedButton = styled(InteractiveElement)`
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: ${borderRadius.standard};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    height: ${`${iconButtonWidth}px`};
    margin-left: 5px;
    .icon {
        margin-bottom: 6px;
        margin-left: 8px;
    }
`;

export const StyledChecklistPopover = styled(Popover)`
    .MuiPopover-paper {
        padding: 10px 15px;
    }
    min-width: 150px;
    display: flex;
    flex-direction: column;
    > * {
        padding: 0 15px;
    }
`;
